import {DataFrameColumnDef, isColumnTypeNumerical} from 'data-frames/DataFrameTypes';
import {UserFacingFilter, isListValueOperator} from 'data-frames/filters/DataFrameFilterTypes';
import {BenchlingTypeDef, LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {List} from 'data-types/benchling-type-def/ComplexTypes';

/** @package */
export default function getTypeDefForFilterValue(
  filter: UserFacingFilter,
  columnDef: DataFrameColumnDef
): BenchlingTypeDef {
  const leafType = columnDef.type.leafType;

  if (isListValueOperator(filter.operator)) {
    return new List(leafType);
  } else if (isColumnTypeNumerical(columnDef.type)) {
    return LeafType.DECIMAL;
  }

  return leafType;
}
